import React, { useEffect, useState } from 'react'
import { over } from 'stompjs';
import SockJS from 'sockjs-client';
import ModalAccess from "../pages/modals/ModalAccess";

var stompClient = null;

const Socket = () => {
    const [showModal, setShowModal] = useState(false);
    const [firstRun, setFirstRun] = useState(false);
    const [userData, setUserData] = useState({
        name: '',
        photo: '',
        connected: false,
        status: '',
        aa: '',
        message: '',
        box: '',
        pesas: ''
    });

    const closeModalAccess = e => {
        setShowModal(false);
    }

    useEffect(() => {
        
        if (!firstRun) {
            setFirstRun(true);
            connect();
        }

        window.onbeforeunload = function() {
            stompClient.disconnect();
            return true;
        };
    
        return () => {};

    }, [userData]);

    const connect = () => {
        let Sock = new SockJS('http://198.251.70.43:8081/ws');
        stompClient = over(Sock);
        stompClient.connect({}, onConnected, onError);
    }

    const onConnected = () => {
        setUserData({ ...userData, "connected": true });
        stompClient.subscribe('/access/web', onMessageReceived);
    }

    const onMessageReceived = (payload) => {
        var payloadData = JSON.parse(payload.body);
        
        setShowModal(true);
        setUserData({
            ...userData, "name": payloadData.name, "photo": payloadData.photo, "status": payloadData.status,
            "aa": payloadData.aa, "message": payloadData.message, "box": payloadData.box, "pesas": payloadData.pesas
        });
        setTimeout(() => closeModalAccess(), 10000);
    }

    const onError = (err) => { }

    return (
        <>
            {showModal ? (
                <ModalAccess
                    isOpen={showModal}
                    closeModal={closeModalAccess}
                    name={userData.name}
                    photo={userData.photo}
                    status={userData.status}
                    aa={userData.aa}
                    message={userData.message}
                    box={userData.box}
                    pesas={userData.pesas}
                />
            ) : (
                <></>
            )}
        </>
    )
}

export default Socket
